var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlagiarismSimilarityWordCount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2132_3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66016 3.65918H33.3008V43.4111H36.9997V0H6.66016V3.65918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 36.458L13.6901 44.0693V36.458H5.99609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1693 18.1562C14.8001 18.1562 14.5 18.4531 14.5 18.8184V21.4658C14.5 21.8311 14.8001 22.1279 15.1693 22.1279C15.5385 22.1279 15.8386 21.8311 15.8386 21.4658V18.8184C15.8386 18.4531 15.5385 18.1562 15.1693 18.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42649 27.4238H23.9141C24.6525 27.4238 25.2527 26.8301 25.2527 26.0996H5.08789C5.08789 26.8301 5.68809 27.4238 6.42649 27.4238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8386 10.874C15.8386 10.5088 15.5385 10.2119 15.1693 10.2119C14.8001 10.2119 14.5 10.5088 14.5 10.874V11.5361H15.8386V10.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5311 16.832C22.5311 17.9268 21.6308 18.8184 20.5232 18.8184C19.4156 18.8184 18.5153 17.9277 18.5153 16.832V15.5078H5.08789V24.7754H19.8539V22.4336C19.4601 22.6592 19.003 22.7891 18.5153 22.7891V21.4648C19.2537 21.4648 19.8539 20.8711 19.8539 20.1406H21.1925V24.7744H25.2518V15.5068H22.5301V16.8311L22.5311 16.832ZM11.8243 21.4658C11.8243 22.5605 10.924 23.4521 9.81642 23.4521C8.70882 23.4521 7.80852 22.5615 7.80852 21.4658V18.8184C7.80852 17.7236 8.70882 16.832 9.81642 16.832C10.924 16.832 11.8243 17.7227 11.8243 18.8184V21.4658ZM17.1777 21.4658C17.1777 22.5605 16.2774 23.4521 15.1698 23.4521C14.0622 23.4521 13.1619 22.5615 13.1619 21.4658V18.8184C13.1619 17.7236 14.0622 16.832 15.1698 16.832C16.2774 16.832 17.1777 17.7227 17.1777 18.8184V21.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81578 18.1562C9.44658 18.1562 9.14648 18.4531 9.14648 18.8184V21.4658C9.14648 21.8311 9.44658 22.1279 9.81578 22.1279C10.185 22.1279 10.4851 21.8311 10.4851 21.4658V18.8184C10.4851 18.4531 10.185 18.1562 9.81578 18.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 12.8604H6.42649C5.68809 12.8604 5.08789 13.4541 5.08789 14.1846H25.2527C25.2527 13.4541 24.6525 12.8604 23.9141 12.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.58887V28.4043C0 31.2295 2.32379 33.5283 5.17966 33.5283H16.6505V44.876C16.6505 47.7012 18.9743 50 21.8302 50H30.3396V6.58887H0ZM26.5903 26.0996C26.5903 27.5596 25.3899 28.7471 23.9141 28.7471H6.42646C4.95064 28.7471 3.75025 27.5596 3.75025 26.0996V14.1836C3.75025 12.7236 4.95064 11.5361 6.42646 11.5361H13.1629V10.874C13.1629 9.7793 14.0632 8.8877 15.1708 8.8877C16.2784 8.8877 17.1787 9.77832 17.1787 10.874V11.5361H23.9151C25.3909 11.5361 26.5913 12.7236 26.5913 14.1836V26.0996H26.5903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1921 16.832V15.5078H19.8535V16.832C19.8535 17.1973 20.1536 17.4941 20.5228 17.4941C20.892 17.4941 21.1921 17.1973 21.1921 16.832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2132_3432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlagiarismSimilarityWordCount);
export default __webpack_public_path__ + "static/media/plagiarism_similarity_word_count.fcf81882e48033bb726d493a532d242c.svg";
export { ForwardRef as ReactComponent };